import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { StepPageWrapper } from '@Layout/StepPageWrapper';
import { useNonprofitDescriptionBLogic } from './hooks/useNonprofitDescriptionBLogic';
import { NonprofitDescriptionBForm } from './NonprofitDescriptionBForm';

export const EddNonprofitDescriptionB = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const { formMethods, handleSubmit, isLoading } = useNonprofitDescriptionBLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isLoading}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        text={t('organic.nonprofitDescriptionB.content')}
        textCustomStyle='text-text-main-primary text-[16px] whitespace-pre-line'
        content={t('organic.nonprofitDescriptionB.title')}>
        <NonprofitDescriptionBForm />
      </StepPageWrapper>
    </FormProvider>
  );
};
